import React from 'react';
import './App.css';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import Email from './components/Email';
import Home from './components/Home';
import Portfolio from './components/Portfolio';

const App = () => {
  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path="/email" element={<Email />} />
            <Route path="/portfolio" element={<Portfolio />} />
          </Routes>
        </header>
        <main>
        </main>
      </div>
    </Router>
  );
}

export default App;
